// 使用当前 Axios 版本自带的请求配置类型。
import type { AxiosRequestConfig } from "axios";
// 复用项目的环境网关配置，支持启动命令中的 --uri 参数。
import { baseURL } from "@/const/env";

/** 生成客户端的基础配置；各服务的 basePath 由生成器入口追加。 */
export const serviceConfig: AxiosRequestConfig = {
  // 与现有请求层使用相同的环境网关。
  baseURL: baseURL(),
  // 与现有请求层保持一致的三分钟超时时间。
  timeout: 180000,
};
